/**
 * リンク付きaタグのHTML要素作成
 * @param id HTML要素に設定するID
 * @param url 遷移先のURL
 * @param displayName 画面表示する文字列
 * @param classes aタグに指定したいクラス配列
 * @returns リンク付きaタグのHTML要素の文字列
 */
export function createHtmlElementWithLink(id: string, url: string, displayName: string, classes?: string[]): string {
  if (classes) {
    return `<a id='${id}' class='${classes.join(
      ' '
    )}' href='${url}' target='_blank' aria-label='${displayName}' rel='noopener noreferrer'>${displayName}</a>`;
  }
  return `<a id='${id}' href='${url}' target='_blank' aria-label='${displayName}' rel='noopener noreferrer'>${displayName}</a>`;
}
